import { adminHttpClient } from '../../../../../commons/adminHttpClient'

const removePerksProductClass = (id: string) => {
  return adminHttpClient.delete(`/AdminDashboard/Perks/ClassDesign/RemovePerksProductClass/${id}`, {})
}

export default removePerksProductClass
